import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the studentsDetail state domain
 */

const selectStudentsDetailDomain = state =>
  state.studentsDetail || initialState;

/**
 * Other specific selectors
 */

const makeSelectLoading = () =>
  createSelector(
    selectStudentsDetailDomain,
    substate => substate.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectStudentsDetailDomain,
    substate => substate.error,
  );

const makeSelectId = () =>
  createSelector(
    selectStudentsDetailDomain,
    substate => substate.id,
  );

const makeSelectFirstRender = () =>
  createSelector(
    selectStudentsDetailDomain,
    substate => substate.firstRender,
  );

const makeSelectItemData = () =>
  createSelector(
    selectStudentsDetailDomain,
    substate => substate.itemData,
  );

/**
 * Default selector used by StudentsDetail
 */

const makeSelectStudentsDetail = () =>
  createSelector(
    selectStudentsDetailDomain,
    substate => substate,
  );

export default makeSelectStudentsDetail;
export {
  selectStudentsDetailDomain,
  makeSelectId,
  makeSelectFirstRender,
  makeSelectLoading,
  makeSelectError,
  makeSelectItemData,
};
